import { render, staticRenderFns } from "./CommissionBreakdown.vue?vue&type=template&id=536f402d&"
import script from "./CommissionBreakdown.vue?vue&type=script&lang=js&"
export * from "./CommissionBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports